import { ReactNode } from "react";
import FocusLock from "@ingka/focus-lock";

type FixaFocusLockProps = {
  onEscaped?: () => void;
  locked?: boolean;
  autoFocus?: boolean;
  children?: ReactNode;
};

function FixaFocusLock(props: FixaFocusLockProps) {
  return <FocusLock {...props} />;
}

export default FixaFocusLock;
